import React from 'react';
import SocialIcons from './SocialIcons';

function Topnav(props){
    // console.log("props.dealer", props.dealerName);
    let toplinks = null;
    let linkStyle = null;
    
    linkStyle = {
        color : props.linkStyle.color || '#FFF'
    };

    if(props.links){
        toplinks = props.links.map((link, index) => {
            if(!link.custom_button){
                return <li key={link.link+index} className="nav-item"><a style={linkStyle} className="nav-link" href={link.link} target={link.newwindow === true ? '_blank':'' }>{link.label}</a></li>
            }
        });
    }

    if(props.template === "LINKED_UP" || props.template === "LINKED_UP_LEFT" || props.template === "LINKED_UP_FOOTER" || props.template === "LINKED_UP_LEFT_FOOTER" || props.template === "LP_LINKS_WITH_ICONS"){
        toplinks = <SocialIcons iconLinks={props.links} template={props.template} dealerName={props.dealerName} shareurl={props.shareurl} />
    }
    
    if(props.template === "SOCIALIZE" || props.template === "SOCIALIZE_FOOTER"){
        return(
        <div className="collapse navbar-collapse" id="navbarsExampleDefault">
            <ul className = "navbar-nav d-flex justify-content-end nav-round">
                {toplinks}
            </ul>
        </div>
    );
}else{
    return(
        <div className="collapse navbar-collapse" id="navbarsExampleDefault">
            <ul className = "navbar-nav d-flex justify-content-end">
                {toplinks}
            </ul>
        </div>
    );

}

    

}

export default Topnav;


// WEBPACK FOOTER //
// ./src/components/Topnav.js